<div class="mobile-app-links">
  <div class="mobile-app-links__description">{{ 'login.mobile-links.description' | translate }}</div>
  <div class="mobile-app-links__content">
    <a class="mobile-app-links__link" target="_blank" [href]="appStoreApplicationLink">
      <img height="40" width="118" [ngSrc]="'assets/icons/login/mobile-links/app-store.svg'" [alt]="'login.alts.app-store' | translate" />
    </a>
    <a class="mobile-app-links__link" target="_blank" [href]="googlePlayApplicationLink">
      <img
        height="40"
        width="137"
        [ngSrc]="'assets/icons/login/mobile-links/google-play.svg'"
        [alt]="'login.alts.google-play' | translate"
      />
    </a>
  </div>
</div>
